import { render, staticRenderFns } from "./TwoFactorValidation.vue?vue&type=template&id=5bf7079c&scoped=true"
import script from "./TwoFactorValidation.vue?vue&type=script&lang=js"
export * from "./TwoFactorValidation.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorValidation.vue?vue&type=style&index=0&id=5bf7079c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf7079c",
  null
  
)

export default component.exports